import styles from './ErrorMessage.module.css';

export default function ErrorMessage({ children }: { children: React.ReactNode }) {
  return (
    <span role="alert" className={styles.errorMessage}>
      {children}
    </span>
  );
}
